import { javaApiInstance } from 'functions/request';

export const fetchApi = ({ id }) => javaApiInstance.get(`/api/my/v1/karmaearn/games/offer/${id}`);
